import { createReducer } from '@reduxjs/toolkit';
import { toLower } from 'lodash';

import { AssignedWorkflow, AvailableWorkflowTemplate } from 'data/models/Workflows';
import {
  loadAssignedWorkflowsAction,
  loadAvailableWorkflowTemplatesAction,
  loadHouseholdHeaderAssignedWorkflowsAction,
  removeAssignedWorkflowAction,
  resetAvailableWorkflowTemplatesAction,
  resetWorkflowsStateAction,
  setAssignedWorkflowsLoading,
  setAvailableWorkflowTemplatesLoading,
  setHouseholdHeaderAssignedWorkflowsLoading,
  updateAssignedWorkflowsAction,
} from 'data/actions/workflows';

interface State {
  isAvailableWorkflowTemplatesLoading: boolean;
  availableWorkflowTemplates: AvailableWorkflowTemplate[];
  isAssignedWorkflowsLoading: boolean;
  assignedWorkflows: AssignedWorkflow[];
  householdHeaderAssignedWorkflows: AssignedWorkflow[];
  isHouseholdHeaderAssignedLoading: boolean;
}

const initialState: State = {
  availableWorkflowTemplates: [],
  isAvailableWorkflowTemplatesLoading: false,
  isAssignedWorkflowsLoading: false,
  assignedWorkflows: [],
  householdHeaderAssignedWorkflows: [],
  isHouseholdHeaderAssignedLoading: false,
};

export default createReducer(initialState, builder => {
  builder.addCase(setAvailableWorkflowTemplatesLoading, (state, action) => {
    state.isAvailableWorkflowTemplatesLoading = action.payload;
  });

  builder.addCase(loadAvailableWorkflowTemplatesAction, (state, action) => {
    state.availableWorkflowTemplates = [...action.payload].sort((a, b) =>
      toLower(a.workflowTemplateName).localeCompare(toLower(b.workflowTemplateName)),
    );
  });

  builder.addCase(setAssignedWorkflowsLoading, (state, action) => {
    state.isAssignedWorkflowsLoading = action.payload;
  });

  builder.addCase(loadAssignedWorkflowsAction, (state, action) => {
    state.assignedWorkflows = [...action.payload].sort((a, b) => toLower(a.name).localeCompare(toLower(b.name)));
  });

  builder.addCase(updateAssignedWorkflowsAction, (state, action) => {
    const dashboardIndex = state.assignedWorkflows.findIndex(assignedWorkflow => assignedWorkflow.id === action.payload.id);
    if (dashboardIndex !== -1) {
      state.assignedWorkflows[dashboardIndex] = action.payload;
    }
    const householdHeaderIdx = state.householdHeaderAssignedWorkflows.findIndex(assignedWorkflow => assignedWorkflow.id === action.payload.id);
    if (householdHeaderIdx !== -1) {
      state.householdHeaderAssignedWorkflows[householdHeaderIdx] = action.payload;
    }
  });

  builder.addCase(removeAssignedWorkflowAction, (state, action) => {
    state.assignedWorkflows = state.assignedWorkflows.filter(workflow => workflow.id !== action.payload);
    state.householdHeaderAssignedWorkflows = state.householdHeaderAssignedWorkflows.filter(workflow => workflow.id !== action.payload);
  });

  builder.addCase(setHouseholdHeaderAssignedWorkflowsLoading, (state, action) => {
    state.isHouseholdHeaderAssignedLoading = action.payload;
  });

  builder.addCase(loadHouseholdHeaderAssignedWorkflowsAction, (state, action) => {
    state.householdHeaderAssignedWorkflows = [...action.payload].sort((a, b) => toLower(a.name).localeCompare(toLower(b.name)));
  });

  builder.addCase(resetAvailableWorkflowTemplatesAction, (state, action) => {
    state.availableWorkflowTemplates = initialState.availableWorkflowTemplates;
  });

  builder.addCase(resetWorkflowsStateAction, (state, action) => {
    return initialState;
  });
});
